"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PositionVideosJob = void 0;

var _Queue = require("../Queue");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PositionVideosJob = /*#__PURE__*/function (_QueueItem) {
  _inherits(PositionVideosJob, _QueueItem);

  var _super = _createSuper(PositionVideosJob);

  function PositionVideosJob(mainSources, subSources, container, subContainer, videos, open) {
    var _this;

    _classCallCheck(this, PositionVideosJob);

    _this = _super.call(this);
    _this._name = "PositionVideosJob";
    _this.mainSources = mainSources;
    _this.subSources = subSources;
    _this.containerElement = container;
    _this.subVideoContainerElement = subContainer;
    _this.sourceChooserOpen = open;
    _this.videoElements = videos;
    return _this;
  }

  _createClass(PositionVideosJob, [{
    key: "run",
    value: function () {
      var _run = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("PositionVideosJob run ", this.mainSources);
                this.positionVideos();
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function run() {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }, {
    key: "positionVideos",
    value: function positionVideos() {
      console.log("PositionVideosJob positionVideos", this.mainSources);
      var isDesktop = window.innerWidth >= 768;
      var subWidth = isDesktop ? 250 : 108;
      var cw = this.containerElement.offsetWidth;
      var ch = this.containerElement.offsetHeight; // position sub video drawer & events panel

      if (this.subVideoContainerElement) {
        var subVideoContainerClassNames = ["sub-videos"];

        if (this.sourceChooserOpen) {
          subVideoContainerClassNames.push("open");
        }

        this.subVideoContainerElement.className = subVideoContainerClassNames.join(" ");
        var usableWidth = this.mainSources.length * subWidth;

        if (isDesktop) {
          usableWidth += 56;
        }

        this.subVideoContainerElement.children[0].style.width = "".concat(usableWidth + 56, "px");
        this.subVideoContainerElement.children[0].style.maxWidth = "".concat(usableWidth + 56, "px");
      } //// position main video


      var mainSources = this.mainSources; // no main sources, create some fake ones to postion
      // video elements anyway

      if (mainSources.length === 0) {
        var _iterator = _createForOfIteratorHelper(this.videoElements),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var el = _step.value;

            if (el.id.contains("main")) {
              mainSources.push({
                video: el,
                container: null,
                active: false
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      var _iterator2 = _createForOfIteratorHelper(mainSources),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var source = _step2.value;

          if (source.video) {
            var r = 9 / 16;

            if (source.video.readyState >= 3) {
              r = source.video.offsetHeight / source.video.offsetWidth;
            }

            var w = cw;
            var h = cw * r;
            var x = 0;
            var y = (ch - h) / 2;

            if (h > ch) {
              r = 16 / 9;

              if (source.video.readyState >= 3) {
                r = source.video.offsetWidth / source.video.offsetHeight;
              }

              h = ch;
              w = h * r;
              y = 0;
              x = (cw - h * r) / 2;
            }

            source.video.style.height = "".concat(h, "px");
            source.video.style.width = "".concat(w, "px");
            source.video.style.top = "".concat(y, "px");
            source.video.style.left = "".concat(x, "px");
            source.video.style["z-index"] = 0;
            source.video.style["border-radius"] = "0px";
            source.video.style["border-width"] = "0px";
            source.video.style["opacity"] = source.active ? 1 : 0;
            source.video.dataset["active"] = source.active;
            console.log("PositionVideosJob position main video", source.video.id, source.active, cw, ch);
          } else {
            console.log("PositionVideosJob position main missing video", source);
          }
        } // position and update sub videos

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(this.subSources.entries()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var src = _step3.value;

          if (src.container) {
            src.container.style["border-color"] = src.active ? "var(--warning-color)" : "rgba(255,255,255,0.25)";
          }

          if (src.video) {
            src.video.dataset["active"] = src.active;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "debugPositionVideos",
    value: function debugPositionVideos() {
      var isDesktop = window.innerWidth >= 768 || window.innerHeight > 768;
      var subWidth = isDesktop ? 250 : 159;
      var cw = this.containerElement.offsetWidth; // position sub video drawer & events panel

      if (this.subVideoContainerElement) {
        var subVideoContainerClassNames = ["sub-videos"];

        if (this.sourceChooserOpen) {
          subVideoContainerClassNames.push("open");
        }

        this.subVideoContainerElement.className = subVideoContainerClassNames.join(" ");
        var usableWidth = this.mainSources.length * subWidth;
        this.subVideoContainerElement.children[0].style.width = "".concat(usableWidth, "px");
      } //// position main video


      var mainSources = this.mainSources; // no main sources, create some fake ones to postion
      // video elements anyway

      if (mainSources.length === 0) {
        var _iterator4 = _createForOfIteratorHelper(this.videoElements),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var el = _step4.value;

            if (el.id.contains("main")) {
              mainSources.push({
                video: el,
                container: null,
                active: false
              });
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      var vw = cw / 3;
      var vh = cw / 3;
      var col = 0;
      var row = 0;
      var i = 0;

      var _iterator5 = _createForOfIteratorHelper(mainSources),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var source = _step5.value;

          if (source.video) {
            var r = 9 / 16;

            if (source.video.readyState >= 3) {
              r = source.video.offsetHeight / source.video.offsetWidth;
            }

            var w = vw;
            var h = vw * r;
            var x = col * vw;
            var y = row * vh;
            source.video.style.height = "".concat(h, "px");
            source.video.style.width = "".concat(w, "px");
            source.video.style.top = "".concat(y, "px");
            source.video.style.left = "".concat(x, "px");
            source.video.style["z-index"] = 0;
            source.video.style["border-radius"] = "0px";
            source.video.style["border-width"] = "2px";
            source.video.dataset["active"] = source.active;
            col++;

            if (i % 3 === 2) {
              col = 0;
              row++;
            }

            i++;
          }
        } // position and update sub videos

      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var _iterator6 = _createForOfIteratorHelper(this.subSources.entries()),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var src = _step6.value;

          if (src.container) {
            src.container.style["border-color"] = src.active ? "var(--warning-color)" : "rgba(255,255,255,0.25)";
          }

          if (src.video) {
            src.video.dataset["active"] = src.active;
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }]);

  return PositionVideosJob;
}(_Queue.QueueItem);

exports.PositionVideosJob = PositionVideosJob;